import { Tag } from "../attachement/attachement.model";
export class checkEctivityMailResponse{
    OutlookConversationId:string;
    OutlookItemId:string;
    ActivityId:number;
    Activity:Activities;
}
export class Activities {
  ActivityID: number;
  Title: string;
  ActivityLocationID: number;
  AddressID: number;
  Description: string;
  ActivityStatusID: number = ActivityStatusEnum.Due;
  ActivityTypeID: number;
  PriorityID: number;
  // OwnerID: number;
  StartDate: Date = new Date();
  EndDate: Date = new Date(new Date().setHours(new Date().getHours() + 2));
  IsAllDayEvent: boolean = false;
  IsLimitedToMembers: boolean = false;
  IsAllowedToEdit: boolean = false;
  TaskID: number;
  CompanyBranchID: number;
  PreparedByID: number;
  PreparedByName: string;
  CallUseID: number;
  Phone: string;
  Sender: string;
  ActivityLocation: ActivityLocation = new ActivityLocation();
  Tags: Tag[] = [];
  Reminder: Reminder[] = [];
  ActivityParticipants: ActivityParticipant[] = [];
  OldPaticipants: string[] = [];
  ActivityPurposes: ActivityPurpose[] = [];
  ActivityEMails: ActivityEMail[] = [];
  ActivityTopics: ActivityTopic[] = [];
  OutlookConversationId:string;
  OutlookItemId:string;
  //EmailData: EmailData = new EmailData();
}
export enum ActivityTypesEnum {
  All = 0,
  Visits = 1,
  Visit = 1,
  Email = 3,
  Mail = 3,
  Meetings = 2,
  Meeting = 2,
  Call = 4,
}
export enum ActivityStatusEnum {
  /*Planned = 1,
  NotReported = 2,
  Done = 3,*/
  Planned = 1,
  Overdue= 2,
  Done  = 3,
  Due = 4,
  Cancelled = 5
}
export enum ActivityEMailsTypesEnum{
    EmailFrom = 0,
    EmailTo = 1,
    EmailCC = 2,
    EmailBCC = 3
}
export class ActivityLocation {
  ActivityID: number;
  ActivityLocationID: number;
  RelatedToTypeID: number;
  RelatedToID: number;
  LocationTitle: string;
  LocationCity: string;
  AddressID: number;
}
export class ActivityParticipant {
  ActivityParticipantID: number;
  ParticipantID: number;
  ParticipantTypeID: number;
  Company: string;
  Position: string;
  HasSigned: boolean;
  Attended: boolean;
  RelatedToTypeID: number;
  RelatedToID: number;
  ActivityID: number;
  Name: string;
  Title: string;
  IsSelected: boolean;
  Type: number;

}
export class ParticipantView {// properties int in the bindingmodel
  Name: string;
  Client: string;
  Job: string;
  Title: string;
  //not exist in the binding model 
  ID: number
  IsSelected: boolean;
  Type: number;
  ActivityID: number;
}
export class Reminder {
  Id: number;
  TypeId: number;
  BranchId: number;
  RelatedToId: number;
  RelatedToTypeId: number;
  ReminderTimeUnit: number = 1;
  ReminderTimeUnitId: number = 8;//Enum ReminderTimeUnitEnum
  CreationDate: Date;
  EventDate: Date;
  ReminderDate: Date;
  TimeZone: number;
  ReminderTitle: string;
  RemindedUserId: number;
  CreatedById: number;
}
export class ActivityPurpose {
  ActivityPurposeID: number;
  Purpose: string;
  ActivityID: number;
  VisitPurposeId: number;
}
export class ActivityEMail {
  EMail: string;
  ActivityEMailID: number;
  ActivityID: number;
  Type: number;
}
export class ActivityTopic {
  ActivityTopicID: number;
  ActivityID: number;
  TopicTitle: string;
  DisplayOrder: number;
  ParentID: number;
  ActivityActions: ActivityAction[];
  //frontend variables
  isOpen: boolean = false;
  DisplayTopicIndex: number;
  DisplaySubTopicIndex: number;
  saved: boolean;
}
export class ActivityAction {
  ActivityID: number;
  ActivityTypeID: number;
  ActivityActionID: number;
  ActivityTopicID: number;
  ActionTitle: string;
  ActivityActionTypeID: number;
  DisplayOrder: number;
  DueDate: Date;
  TaskID: number;
  ResponsibleID: number;
  ResponsibleName: string;
  IsResponsibleUser: boolean;
  CreatedByID: number;
  CreatedDate: Date;
  ModifiedDate: Date;
  Comments: Comment[];
  Tags: Tag[];
  //frontend variables
  isActive: boolean;
  _hover: boolean;
  _MentionDatasource: any[] = [];
}